<template>
  <div class="page-with-top-bar">
    <project-template-admin-quick-buttons hiddenOption="chapters"/>
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="stream"></b-icon>
              <span> {{ $t('chapters') }} </span>
            </template>
            <div>
              <manage-chapters
                :projectId="projectId"
                :entityType="'project-template'"
              ></manage-chapters>
            </div>
          </b-tab-item>

        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ProjectTemplateAdminQuickButtons from '../../../components/project-template-admin-quick-buttons.vue'
  import ManageChapters from '../../../components/chapters/manage-chapters'

  export default {
    middleware: 'auth',
    title: 'manage_statuses_page_title',
    menuOption: '0-6',

    components: {
      ManageChapters,
      ProjectTemplateAdminQuickButtons
    },

    data: () => ({
      mainActiveTab: 0,
    }),

    computed: {
      ...mapGetters({
        project: "template/project"
      }),

      projectId() {
        return parseInt(this.$route.params.template_id);
      }

    },

    watch: {
      mainActiveTab(value) {
        if (value == 0) {
          this.$refs.project_locations_manual.reload()
        }
      }
    },

    created() {
      let projectName = this.project.name
        ? this.project.name.toUpperCase()
        : "";
      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];
    },

    methods: {}
  };
</script>
